<template>
  <div class="validation_request_order" :class="{ 'detailed-view': isDetails }">
    <div class="validation_request_order_head">
      <div class="head">
        <h4>Commande n° {{order.ihrez}} : <strong>{{order.decoded_payment_status}}</strong></h4>
      </div>
      <p>
        <em>
            Crée le {{order.created_at | moment-date }} |
            Mis à jour le {{order.updated_at | moment-date }}
        </em>
      </p>
      <payment-item 
          v-if="order.payment_status == 'paid' && order.payments && order.payments.length > 0"
          :payment="order.payments[0]"></payment-item>
      <div v-else>Mode de validation : {{ order.decoded_validation_method }}</div>
    </div>
    <div v-if="order.suborders">
      <suborders v-for="(suborder, idx) in order.suborders" :key="'suborder-' + idx" :suborder="suborder">
        <div class="tarif">
          <h5>Tarification</h5>
          <div class="validation_request_order_infos">
            <div class="order_infos_centered">
              <div class="order_value_container">
                <div class="order_value_container_row">
                  <div class="order_value">
                    <h5 class="text-white p-b-5">{{(order.total_ht / 100).toFixed(2)}} €</h5>
                    <span class="fs-13">Sous-total H.T.</span>
                  </div>
                  <div class="order_value order_value_middle">
                    <h5 class="text-white p-b-5">{{(order.tax_amount / 100).toFixed(2)}} €</h5>
                    <span class="fs-13">T.V.A. ({{(order.tax_rate * 100).toFixed(2)}}%)</span>
                  </div>
                  <div class="order_value">
                    <h5 class="text-white p-b-5">{{(order.total_ttc / 100).toFixed(2)}} €</h5>
                    <span class="fs-13">Sous-total T.T.C</span>
                  </div>
                </div>
                <hr style="color:white">
                <div class="order_value_container_row">
                  <div class="order_value_2">
                    <h5 class="text-white p-b-5">{{(order.deposit_amount / 100).toFixed(2)}} €</h5>
                    <span class="fs-13">Dépot de garantie</span>
                  </div>
                  <div class="order_value" style="margin-left:auto;">
                    <h5 class="text-white p-b-5">{{(order.total_to_pay / 100).toFixed(2)}} €</h5>
                    <span class="fs-13">Total T.T.C</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </suborders>
    </div>
  </div>
</template>

<script>
import Suborders from "./Order/Suborders"
import PaymentItem from '../../../Payment/Item'

export default {
  name: "ValidationRequestableOrder",

  components: {
    Suborders,
    PaymentItem,
  },

  props: ["order", "isDetails"]
}
</script>

<style scoped>
.validation_request_order {
  width: 80%;
  background-color: white;

}

.validation_request_order_head {
  text-align: center;
  border-bottom: solid 1px lightgray;
  padding-bottom: 20px;
}

.validation_request_order_infos {
  min-width: max-content;
  background-color: #eb7593;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}
.order_value {
  display: inline-block;
  text-align: center;
  width:100px;
}

.order_value_middle {
  padding-left: 5px;
  padding-right: 5px;
}

.order_value_2 {
  display: inline-block;
  text-align: center;
  width:200px;
}

.head {
  width: 100%;
}

.head h4 {
  display: inline-block;
}

.head button {
  display: inline-block;
}

.tarif {
  min-width: -webkit-max-content;
  padding-left: 15px;
}

.tarif h4 {
  text-align: center;
}

@media screen and (max-width: 800px) {
  .validation_request_order {
    border-right:0px;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Order.vue